import { styled, css } from 'styled-components';
export const SliderContainer = styled.div `
  .rc-slider {
    position: relative;
    height: 6px;
    padding: 0;
    width: 100%;
    margin-left: 0px;
    border-radius: 6px;
    touch-action: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background: ${({ theme }) => theme.colors.grey05_1};
    * {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  &[data-at-min='true'] .rc-slider {
    width: calc(100% - 8px);
    margin-left: 8px;
  }

  &[data-at-max='true'] .rc-slider {
    width: calc(100% - 8px);
    margin-left: 0px;
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    height: 6px;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
  }

  .rc-slider-track {
    position: absolute;
    height: 6px;
    background: ${({ theme, $disabled }) => ($disabled ? theme.colors.grey100_1 : theme.colors.main)};
    border-radius: 6px;
  }

  .rc-slider-handle {
    position: absolute;
    z-index: 1;
    width: 36px;
    height: 36px;
    margin-top: -15px;
    border: none;
    border-radius: 50%;
    cursor: grab;
    touch-action: pan-x;
    outline: none;
    box-shadow: none !important;

    &:hover {
      border-color: none;
    }

    &:active {
      cursor: grabbing;
      border-color: none;
      box-shadow: none;
    }

    &:focus {
      border-color: none;
      box-shadow: none;
      outline: none;
    }

    &::before {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      background: ${({ theme }) => theme.colors.grey00_1};
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      border-radius: 50%;
      z-index: 1;
    }
    &::after {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      ${({ theme }) => theme.shadows.medium}
      background: ${({ theme, $disabled }) => ($disabled ? theme.colors.grey100_1 : theme.colors.main)};
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      border-radius: 50%;
    }
  }

  .rc-slider-mark {
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    font-size: 12px;
    height: 12px;
  }

  .rc-slider-mark-text {
    position: absolute;
    display: inline-block;
    cursor: pointer;
    transform: translateX(-50%);
  }

  .rc-slider-mark-text-active {
    color: ${({ theme }) => theme.colors.main};
  }

  ${({ $disabled }) => $disabled &&
    css `
      pointer-events: none;
    `}
`;
export const Mark = styled.span `
  display: block;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.grey10_1};

  .rc-slider-mark-text-active & {
    background: ${({ theme }) => theme.colors.main};
  }
`;
export const ValueLabel = styled.p `
  ${({ theme }) => theme.typography.headline};
  margin: 0 0 13px;
`;
